import { Intent, Spinner as BPSpinner } from '@blueprintjs/core'
import React from 'react'

interface Props {
  size?: number
  style?: React.CSSProperties
  intent?: Intent
}

const Spinner: React.FC<Props> = ({ style = {}, intent, size }) => (
  <div className="spinner" data-testid="spinner" style={{ textAlign: 'center', ...style }}>
    <BPSpinner intent={intent || Intent.NONE} size={size} />
  </div>
)

// workaround for Jest https://github.com/airbnb/enzyme/issues/1875
export { Spinner }
export default React.memo<Props>(Spinner)
